// extracted by mini-css-extract-plugin
module.exports = {"splashscreen":"SplashScreen_index-module_splashscreen--kR_5-","splashLogo":"SplashScreen_index-module_splashLogo--9WPUG"};